import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  SectionA,
  SectionB,
  SectionC,
  SectionD,
  SectionE,
  SectionF,
} from "../../components";
import { PortfolioModal } from "../../components/Modal/PortfolioModal";
import NavBar from "../../components/Nav/NavBar";

function Home() {
  const navigate = useNavigate();
  const [tab, setTab] = useState(1);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedItem, setselectedItem] = useState("");
  return (
    <Container style={{ padding: 0, overflow: "hidden" }} fluid>
      <Row>
        <Col>
          <NavBar color="#9dc318" />
          <SectionA
            title={"Bringing innovative and disruptive technological solutions"}
            body={
              "Delivering innovative solutions to meet the ever-evolving needs of businesses. Our solutions are designed with a focus on user experience, scalability, and security."
            }
            btn={true}
          />
          <SectionB onClick={(res) => {}} />
          <SectionC
            onClick={(res) => {
              setTab(res);
            }}
            onPressItem={(res) => {
              setModalOpen(true);
              setselectedItem(res);
            }}
            tab={tab}
          />

          <div className="horiContainer">
            <SectionD />
          </div>

          <SectionE />
          <div className="horiContainer">
            <SectionF />
          </div>
        </Col>
      </Row>
      <PortfolioModal
        item={selectedItem}
        modalOpen={modalOpen}
        setModalOpen={() => {
          setModalOpen(false);
        }}
      />
    </Container>
  );
}

export default Home;
